module.exports = __webpack_public_path__ + "static/media/employers.20f3a84d.png";